import { QueryClient } from "react-query";

/**
 * Defaults reduzem chamadas duplicadas no dev (React 18 Strict Mode remonta a árvore).
 * Com staleTime + refetchOnMount: false, o segundo mount reutiliza cache em vez de novo GET.
 * Queries podem sobrescrever (ex.: UserContext).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

